import { WorkGeneratorMode, WorkGroupsConfigMode } from './WorkWizardOptions';

export class MtWorkGenerationInfo {
  MtObjectId!: string;
  MtObjWorkTypeId?: string;
  EarliestWorkExecDate?: Date;
  ScheduledWorkExecDate?: Date;
  LatestWorkExecDate?: Date;
  WorkExecTime?: number;

  constructor(obj?: any) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class MtWorkQueryInfo {
  GeneratorMode: WorkGeneratorMode = WorkGeneratorMode.cyclic;
  WorkTypeId?: string;
  ManualEarliestWorkExecDate?: Date;
  ManualScheduledWorkExecDate?: Date;
  ManualLatestWorkExecDate?: Date;

  constructor(obj?: any) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class MtWorkGroupQueryInfo {
  Mode: WorkGroupsConfigMode = WorkGroupsConfigMode.createNew;

  constructor(obj?: any) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export enum WorkCycleUnit {
  weeks = 0,
  months = 1,
  years = 2,
}

export class CyclicWorkCalculator {
  public static readonly DefaultWorkLeadTimeInDays = 7.0;
  public static readonly DefaultWorkExecTimeInDays = 7.0;
}
